export default "__VITE_ASSET__olpe$cVn__"